import { render, staticRenderFns } from "./StudentsViewTabGeneralAvatar.vue?vue&type=template&id=49d2f548"
import script from "./StudentsViewTabGeneralAvatar.vue?vue&type=script&lang=js"
export * from "./StudentsViewTabGeneralAvatar.vue?vue&type=script&lang=js"
import style0 from "./StudentsViewTabGeneralAvatar.vue?vue&type=style&index=0&id=49d2f548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports